import { internalAction } from '@/data/loaders'

export function loadUser({ params }) {
  return internalAction("getUser", { uid: params.uid })
}

export function loadAllUsers() {
  return internalAction("getAllUsers", {})
}

export function loadAllCourses() {
  return internalAction("getAllCourses", {})
}

export function loadAllOrganizations() {
  return internalAction("getAllOrganizations", {})
}
